import FunctionContext from "./context/FunctionContext";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import React from "react";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FunctionContext>
      <App />
    </FunctionContext>
  </React.StrictMode>
);
